export const SERVER_HOST = "/api";
